module.exports = __webpack_public_path__ + "static/media/stores.5956edfd.png";